import { cn } from "@cca/components";
import {
  FeatureGuard,
  FeatureGuardBehaviour,
  FeatureGuardProps,
} from "@core/components";
import { isValidElement, PropsWithChildren } from "react";

import Breadcrumbs, { RouteBreadcrumb } from "./components/Breadcrumbs";

const SecuredPagePadding = {
  default: "px-4 sm:px-6 py-4 lg:px-10 lg:py-6 xl:px-14 xl:py-8",
  none: "p-0",
} as const;

type SecuredPageLayoutProps = PropsWithChildren<{
  padding?: keyof typeof SecuredPagePadding;
  routes?: RouteBreadcrumb[];
  title: React.ReactNode;
  className?: string;
  scrollable?: boolean;
  testId?: string;
}> &
  FeatureGuardProps;

const SecuredPageLayout = ({
  children,
  title,
  routes,
  padding = "default",
  className,
  features,
  scrollable = false,
  testId,
  logic,
  behaviour = FeatureGuardBehaviour.NavigateToAccessDenied,
}: SecuredPageLayoutProps) => (
  <FeatureGuard behaviour={behaviour} features={features} logic={logic}>
    <div
      className={cn({
        "h-full overflow-hidden": !scrollable,
        contents: scrollable,
      })}
    >
      <article
        className={cn(
          SecuredPagePadding[padding],
          "flex min-h-[max(var(--spacing-screen-md),100%)] flex-1 flex-col bg-gray-50",
          !scrollable && "md:h-screen",
          className,
        )}
      >
        <header className="mb-4 sm:mb-6 xl:mb-8">
          <div className="mb-2 flex items-center gap-5">
            {isValidElement(title) ? (
              title
            ) : (
              <h1
                className="text-2xl text-inherit md:text-3xl lg:text-4xl"
                data-testid={testId}
              >
                {title}
              </h1>
            )}
            {/* <ActionButtons className="hidden lg:flex" /> */}
          </div>
          <Breadcrumbs routes={routes} />
        </header>
        {children}
      </article>
    </div>
  </FeatureGuard>
);

export default SecuredPageLayout;
